import React, { useEffect, useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Container, Card, Button } from 'react-bootstrap'
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom'
import Message from '../components/Message.js'
import Loader from '../components/Loader.js'

import {
  deleteReceipt,
  getReceipt,
  getcategoryReceipts
} from '../actions/receiptActions.js'
import CatPaginate from '../components/CatPaginate.js'
import { API_URL } from '../apiUrl.js'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { ThemeContext } from '../components/ThemeContext.js'

const CatReceiptScreen = () => {
  const { theme } = useContext(ThemeContext)
  const { catpageNumber } = useParams() || 1
  const [currentcat, setCurrentcat] = useState('')
  const [imageErrors, setImageErrors] = useState({})

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const categoryReceipts = useSelector((state) => state.categoryReceipts)
  const { catreceipts, loading, catpages, catpage, catcount } = categoryReceipts

  const deleteReceipts = useSelector((state) => state.deleteReceipts)
  const { success } = deleteReceipts

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const formatDate = (value) => {
    if (!value) return ''
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
      .format(new Date(value))
      .replace(/,/g, '')
  }

  const getReceiptImageSrc = (qfname) => {
    return `${API_URL}/receipts/image/${encodeURIComponent(qfname)}`
  }

  const deleteHandler = (rimgid) => {
    if (window.confirm('Are you sure')) {
      dispatch(deleteReceipt(rimgid))
    }
  }

  const editHandler = (id) => {
    navigate(`/receipts/edit/${id}`)
    dispatch(getReceipt(id))
  }

  const location = useLocation()
  const category = location.state?.category

  useEffect(() => {
    if (category) {
      setCurrentcat(category)
    }
  }, [category])

  const activeCategory = category || currentcat

  useEffect(() => {
    if (!userInfo) {
      navigate('/dashboard')
      return
    }

    if (!activeCategory) return

    dispatch(getcategoryReceipts(catpageNumber, activeCategory))
  }, [userInfo, catpageNumber, activeCategory, success, dispatch, navigate])

  return (
    <Container className='my-2' fluid>
      {loading && <Loader />}
      {catcount === 0 && <Message variant='info'>None Found</Message>}
      <CatPaginate catpages={catpages} catpage={catpage} />
      <Row>
        {catreceipts &&
          catreceipts.length > 0 &&
          catreceipts.map((receipt) => (
            <Col key={receipt._id} sm={12} md={6} lg={4} xl={3}>
              <Card
                className='my-3 p-3 rounded'
                style={{
                  width: '18rem',
                  backgroundColor: theme.card,
                  color: theme.text,
                  borderColor: theme.sidebarAccent
                }}
              >
                <Card.Header
                  style={{
                    backgroundColor: theme.surfaceMuted,
                    color: theme.subtext
                  }}
                >
                  <Button className='btn btn-sm'>
                    {receipt.rcategory} <i className='fas fa-tag'></i>
                  </Button>
                </Card.Header>

                <Card.Body>
                  {imageErrors[receipt.rimgid] ? (
                    <div
                      style={{
                        width: '100%',
                        height: '220px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: theme.subtext,
                        backgroundColor: theme.surfaceMuted,
                        borderRadius: '8px',
                        marginBottom: '0.75rem'
                      }}
                    >
                      Image unavailable
                    </div>
                  ) : (
                    <Card.Img
                      src={getReceiptImageSrc(receipt.qfname)}
                      variant='top'
                      alt=''
                      onError={() =>
                        setImageErrors((prev) => ({
                          ...prev,
                          [receipt.rimgid]: true
                        }))
                      }
                    />
                  )}
                  <Link to={`/receipts/${receipt.rimgid}`}>
                    <Card.Title as='div'>
                      {formatDate(receipt.createdAt)}
                    </Card.Title>
                  </Link>
                  <Card.Text as='div'>{receipt.rcptext}</Card.Text>
                </Card.Body>

                <Card.Footer
                  style={{
                    backgroundColor: theme.surfaceMuted,
                    borderColor: theme.sidebarAccent
                  }}
                >
                  <Button
                    variant='primary'
                    block='true'
                    onClick={() => editHandler(receipt._id)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>{' '}
                  <Button
                    variant='danger'
                    block='true'
                    onClick={() => deleteHandler(receipt.rimgid)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          ))}
      </Row>
    </Container>
  )
}

export default CatReceiptScreen
